const GOOGLE_ANALYTICS_TRACKING_IDS = {
    WITHOUT_LOGIN: 'AW-753836733',
    WITH_LOGIN: 'UA-136328369-1',
};
export default GOOGLE_ANALYTICS_TRACKING_IDS;
